export default {
	add_to_calendar: "Añadir al calendario",
	available_on_level: "Disponible en el nivel",
	begin_date: "Fecha Inicial",
	check_in: "Confirmar asistencia",
	checked_in: "Asistencia confirmada",
	code: "Código",
	doesnt_have_a_qrcode_reader_enter_the_check_in_code_bellow: "¿No tienes un lector de QR Code? Ingresa el código de registro a continuación.",
	dont_forget_to_come_and_visit_us_at: "¡Participa en los eventos Intel Lovers!",
	end_date: "Fecha Final",
	enter_the_check_in_code_bellow: "Ingresa el código de registro a continuación.",
	enter_your_six_digits_code: "Ingresa tu código de seis dígitos.",
	event_type: "Tipo de Evento",
	get_back_later_to_check_new_event_available_to_you: "Vuelve después para verificar nuevos eventos disponibles.",
	join_exclusive_events_for_intel_rewards_you_users_and_power_up_your_connection_with_the_intel_network: "Conoce los eventos exclusivos para usuarios de Intel Te Premia y ¡amplía tu red de relacionamiento con la comunidad Intel!",
	no_events_are_available_at_the_moment: "No hay eventos disponibles en este momento. ",
	read_the_qrcode_at_the_event_to_check_in: "Lee el Código QR en el evento para registrarte.",
	read_the_qrcode_available_at_the_event_to_check_in: "Lea el código QR disponible en el evento para marcar su presencia.",
	signed_up: "Inscrito(a)",
	signup: "Inscribirse",
	thank_you_for_participating_in_our_event_see_you_on_the_next_one: "Gracias por participar en nuestro evento. ¡Nos vemos pronto!",
	the_code_sent_is_invalid_confirm_the_code_with_the_event_organization: "El código enviado no es válido. Por favor, confírmalo con la organización del evento."
}